export default {
    search: 'Поиск',
    enter_the_city: 'Введите город',
    to_download: 'для скачивания',
    make_an_appointment: 'назначить встречу',
    only_with: '',
    calculate_route: 'Установите пожалуйчта Ваш маршрут',
    e_conference: 'E--консультация'
}
